import Layout from '../pages/Layouts/BackendLayout.vue'
import {
  getBackendAdminPage as getAdminPage,
  getBackendAgenciesPage as getAgenciesPage,
  getBackendAlertsPage as getAlertsPage,
  getBackendAnualPage as getAnualPage,
  getBackendGeneralPage as getGeneralPage,
} from './utils.js'

const routes = [
  {
    path: '/settings',
    redirect: '/settings/hotel',
    name: 'Settings',
  },
  {
    path: '/settings',
    component: Layout,
    children: [
      {
        path: 'hotel',
        name: 'Hotel',
        components: { default: getGeneralPage('Hotel') },
      },
      {
        path: 'room-types',
        name: 'Room Types',
        components: { default: getGeneralPage('RoomTypes') },
      },
      {
        path: 'boards',
        name: 'Boards',
        components: { default: getGeneralPage('Boards') },
      },
      {
        path: 'segments',
        name: 'Segments',
        components: { default: getGeneralPage('Segments') },
      },
      {
        path: 'export-import',
        name: 'Export / Import',
        components: { default: getGeneralPage('ExportImport') },
      },
      {
        path: 'mail-setup',
        name: 'Mail Setup',
        components: { default: getGeneralPage('MailSetup') },
      },
      {
        path: 'email-template',
        name: 'Email Template',
        components: { default: getGeneralPage('EmailTemplate') },
      },
      {
        path: 'year-seasons',
        name: 'Year Seasons',
        components: { default: getAnualPage('YearSeasons') },
      },
      {
        path: 'seasons',
        name: 'Seasons',
        components: { default: getAnualPage('Seasons') },
      },
      {
        path: 'travel-seasons',
        name: 'Travel Seasons',
        components: { default: getAnualPage('TravelSeasons') },
      },
      {
        path: 'booking-terms',
        name: 'Booking Terms',
        components: { default: getAnualPage('BookingTerms') },
      },
      {
        path: 'target',
        name: 'Target',
        components: { default: getAnualPage('Target') },
      },
      {
        path: 'pricing',
        name: 'Anual Pricing',
        components: { default: getAnualPage('Pricing') },
      },
      {
        path: 'services',
        name: 'Services',
        components: { default: getAnualPage('Services') },
      },
      {
        path: 'agencies',
        name: 'Agencies',
        components: { default: getAgenciesPage('Agencies') },
      },
      {
        path: 'alerts',
        name: 'Alerts',
        components: { default: getAlertsPage('Alerts') },
      },
      {
        path: 'forwards-action',
        name: 'Forwards Actions',
        components: { default: getAdminPage('ForwardsActions') },
      },
      {
        path: 'reload',
        name: 'Reload',
        components: { default: getAdminPage('Reload') },
      },
      {
        path: 'invalidate-action',
        name: 'Invalidate Actions',
        components: { default: getAdminPage('InvalidateActions') },
      },
      {
        path: 'metabase',
        name: 'Metabase',
        components: { default: getAdminPage('Metabase') },
      },
    ],
  },
]

export default routes
